<template>
  <div>
    <v-row dense :key="order.id" class="mb-15">
      <template v-if="step == 1">
        <v-col cols="12" md="12">
          <PartnerItems
            :key="`partner_items_${order.id}_${services.length}_${assets.length}`"
            :info="order"
            :services="services"
            :assets="assets"
            :summary="summary"
            ref="itemRef"
            @onUpdate="onUpdate"
          />
        </v-col>
        <v-col cols="12">
          <PartnerDelivery
            :key="`partner_delivery_${order.id}_${deliveryAddress.length}`"
            :info="order"
            :services="services"
            :summary="summary"
            :delivery-address="deliveryAddress"
            ref="itemRef"
            @onUpdate="onUpdate"
          />
        </v-col>
      </template>
      <template v-else-if="step == 2">
        <v-col cols="12" md="12">
          <Payment
            :info="order"
            :summary="summary"
            :is-show-card-payment="false"
            ref="paymentRef"
            @onUpdate="onUpdate"
            @goBack="goBack"
          />
        </v-col>
      </template>
      <template v-else-if="step == 3">
        <v-col cols="12" md="12">
          <Success
            :info="order"
            :summary="summary"
            type="partner"
            ref="successRef"
            @onUpdate="onUpdate"
          />
        </v-col>
      </template>
    </v-row>
    <div class="fixed-bottom-block">
      <v-row dense>
        <template v-if="step == 1">
          <v-col cols="6">
            <v-btn color="error" small block @click="resetAll">
              {{ order.id ? $t("Hủy đơn") : $t("Làm lại") }}
            </v-btn>
          </v-col>
          <v-col cols="6">
            <v-btn color="success" small block @click="saveProcessing">
              {{ $t("Tiếp") }}
            </v-btn>
          </v-col>
        </template>
        <template v-else-if="step == 2">
          <v-col cols="12">
            <v-btn color="warning" small block @click="goBack">
              {{ $t("Quay lại") }}
            </v-btn>
          </v-col>
        </template>
        <template v-else-if="step == 3">
          <v-col cols="12">
            <v-btn
              color="purple"
              class="white--text"
              small
              block
              @click="pageReload"
            >
              {{ $t("Thêm yêu cầu mới") }}
            </v-btn>
          </v-col>
        </template>
      </v-row>
    </div>
  </div>
</template>

<script>
import { httpClient } from "@/libs/http";
import { httpNoLoading } from "@/libs/httpNoLoading";
import { debounce } from "lodash";
import { ORDER_STATUS } from "@/libs/const";

export default {
  name: "Contract",
  components: {
    PartnerItems: () => import("@/components/rent/PartnerItems"),
    Payment: () => import("@/components/rent/Payment"),
    Success: () => import("@/components/rent/Success"),
    PartnerDelivery: () => import("@/components/rent/PartnerDelivery"),
  },
  data: () => ({
    order: {
      id: "",
    },
    channels: [],
    countries: [],
    services: [],
    vouchers: [],
    assets: [],
    deliveryAddress: [],
    step: 1,
    me: {},
    isLoading: false,
    orderInterval: 0,
  }),
  computed: {
    selectedService() {
      if (!this.order.rent_day || !this.order.id_asset || !this.me.id) {
        return [];
      }

      return [...this.services].find(
        (s) =>
          s.id_asset == this.order.id_asset &&
          (s.id_account == this.me.id ||
            (s.id_city == this.me.id_city && s.id_account == -1)) &&
          s.from_day <= this.order.rent_day &&
          s.to_day >= this.order.rent_day
      );
    },
    summary() {
      const data = {
        total_price: 0,
        id_service: 0,
      };

      if (!this.selectedService) {
        return data;
      }

      const itemAmount = this.selectedService.price * this.order.rent_day;
      data.total_price = Math.round(itemAmount);
      data.id_service = this.selectedService.id;

      return data;
    },
  },
  mounted() {
    const { me } = window;
    this.me = { ...me };
    this.orderInterval = setInterval(() => {
      this.reCheckOrder();
    }, 5000);

    this.getProcessing();
    this.getAssets();
    this.getCountries();
    this.getChannels();
    this.getServices();
    this.getDeliveryAddress();
    this.listenSocket();
  },
  methods: {
    async reCheckOrder() {
      if (!this.order || !this.order.id || this.step != 2) {
        return false;
      }

      const { data } = await httpNoLoading.post("/order/v1/get-detail", {
        id_order: this.order.id,
      });

      if ([ORDER_STATUS.DEPOSIT, ORDER_STATUS.ON_GOING].includes(data.status)) {
        this.step = 3;
      }
    },

    async getDeliveryAddress() {
      const { data } = await httpClient.post("/me/v1/get-delivery-address");
      this.deliveryAddress = [...data];
    },
    async getProcessing() {
      const res = await httpClient.post("/order/v1/get-processing-contract");
      if (res && res.data && res.data.id) {
        const { data } = await httpClient.post("/order/v1/get-detail", {
          id_order: res.data.id,
        });
        this.order = { ...data };
        console.log("this.order", this.order);
      }
    },
    async resetAll() {
      if (this.order.id) {
        const id_order = this.order.id;
        await httpClient.post("/order/v1/cancel-processing", {
          id_order,
        });
      }
      setTimeout(() => {
        this.pageReload();
      }, 500);
    },

    pageReload() {
      window.location.reload();
    },

    nextStep() {
      this.step++;
    },
    goBack() {
      this.step--;
    },

    onUpdate: debounce(function (order) {
      this.order = { ...this.order, ...order };
    }, 200),

    async saveProcessing() {
      if (!this.summary.id_service) {
        this.$vToastify.error(this.$t("Không có dịch vụ khả dụng"));
        return false;
      }

      if (!this.order.start_time) {
        this.$vToastify.error(this.$t("Chưa chọn thời gian nhận xe"));
        return false;
      }

      const delivery = [...this.deliveryAddress].find(
        (d) => d.id == this.order.id_account_delivery_address
      );

      try {
        const { data } = await httpClient.post(
          "/order/v1/save-processing-contract",
          {
            ...this.order,
            ...this.summary,
            delivery_id_city: (delivery && delivery.id_city) || null,
            delivery_id_county: (delivery && delivery.id_county) || null,
            delivery_id_ward: (delivery && delivery.id_ward) || null,
            delivery_address: (delivery && delivery.address) || null,
          }
        );
        this.order = { ...this.order, ...data };
        if (this.order.is_allow_debt) {
          this.step = 3;
        } else {
          this.nextStep();
        }
      } catch (e) {
        const errMsg =
          (e.response &&
            e.response.data &&
            e.response.data.error &&
            e.response.data.error.message) ||
          null;
        this.$vToastify.error(errMsg);
      }
    },

    listenSocket() {
      window.socket.on("order_paid", (data) => {
        console.log("listenSocket->data", data);

        const { id_order } = data;

        if (id_order == this.order.id && this.step == 2) {
          this.step = 3;
        }
      });
    },

    async getCountries() {
      const { data } = await httpClient.post("/common/v1/get-country");
      this.countries = [...data];
    },

    async getChannels() {
      const { data } = await httpClient.post("/common/v1/get-channel", {
        type: 2,
      });
      this.channels = [...data];
    },

    async getAssets() {
      const { data } = await httpClient.post("/asset/v1/get-by-contract");
      this.assets = [...data];
    },

    async getServices() {
      const { data } = await httpClient.post("/common/v1/get-service");
      this.services = [...data];
    },
  },
};
</script>
